import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/chatagent-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row full-width justify-center bg-primary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.pitchyou.de",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "img-fluid"
      })
    ])
  ])
], -1)

import { ref, onMounted } from 'vue';
import SmallFooter from '@/components/SmallFooter.vue';
import { TenantLoginInfo } from '@/store/models';
import tenantModule from '@/store/modules/tenantModule';

//import { useI18n } from 'vue-i18n';

// const { t, locale } = useI18n();


export default /*#__PURE__*/_defineComponent({
  __name: 'CenteredLayout',
  setup(__props) {

const tenantLoginInfo = ref<TenantLoginInfo | null>(null);
const hideHeader = ref(false);



onMounted(async () => {
  await loadTenantLoginInfo();
  if (tenantLoginInfo.value) {
    hideHeader.value = !tenantLoginInfo.value.hideLogin;
  }
});

const loadTenantLoginInfo = async () => {
  tenantLoginInfo.value = tenantModule.tenantLoginInfo || null;
  if (!tenantLoginInfo.value) {
    await tenantModule.loadTenantLoginInfo();
    tenantLoginInfo.value = tenantModule.tenantLoginInfo;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hhh lpr fff",
    class: "bg-primary"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_header, { class: "bg-primary text-white" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 512), [
        [_vShow, hideHeader.value]
      ]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_page, { class: "bg-primary flex justify-center items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SmallFooter)
    ]),
    _: 1
  }))
}
}

})